/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseUpdateDto
 */
export interface HorseUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof HorseUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HorseUpdateDto
     */
    colorId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HorseUpdateDto
     */
    breedId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof HorseUpdateDto
     */
    birthday?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof HorseUpdateDto
     */
    motherRegId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseUpdateDto
     */
    fatherRegId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HorseUpdateDto
     */
    isBigHorse?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HorseUpdateDto
     */
    size?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HorseUpdateDto
     */
    ownerRegId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseUpdateDto
     */
    breederRegId?: string | null;
}

/**
 * Check if a given object implements the HorseUpdateDto interface.
 */
export function instanceOfHorseUpdateDto(value: object): value is HorseUpdateDto {
    return true;
}

export function HorseUpdateDtoFromJSON(json: any): HorseUpdateDto {
    return HorseUpdateDtoFromJSONTyped(json, false);
}

export function HorseUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'colorId': json['colorId'] == null ? undefined : json['colorId'],
        'breedId': json['breedId'] == null ? undefined : json['breedId'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'motherRegId': json['motherRegId'] == null ? undefined : json['motherRegId'],
        'fatherRegId': json['fatherRegId'] == null ? undefined : json['fatherRegId'],
        'isBigHorse': json['isBigHorse'] == null ? undefined : json['isBigHorse'],
        'size': json['size'] == null ? undefined : json['size'],
        'ownerRegId': json['ownerRegId'] == null ? undefined : json['ownerRegId'],
        'breederRegId': json['breederRegId'] == null ? undefined : json['breederRegId'],
    };
}

export function HorseUpdateDtoToJSON(json: any): HorseUpdateDto {
    return HorseUpdateDtoToJSONTyped(json, false);
}

export function HorseUpdateDtoToJSONTyped(value?: HorseUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'colorId': value['colorId'],
        'breedId': value['breedId'],
        'birthday': value['birthday'] == null ? undefined : ((value['birthday'] as any).toISOString().substring(0,10)),
        'motherRegId': value['motherRegId'],
        'fatherRegId': value['fatherRegId'],
        'isBigHorse': value['isBigHorse'],
        'size': value['size'],
        'ownerRegId': value['ownerRegId'],
        'breederRegId': value['breederRegId'],
    };
}

